import { ArrowDown, ArrowUp } from "lucide-react";
import { cn } from "web-design-system";
import { formatAsPercentage } from "creso-core/utils";

export function ValueVector({
  value,
  precision = 2,
  formatter = (v) => formatAsPercentage(Math.abs(Number(v)), "N/A", precision),
  className,
}: {
  value?: string | number | null;
  precision?: number;
  formatter?: (value: number) => React.ReactNode;
  className?: string;
}) {
  const numericValue = Number(value);
  const isPositive = numericValue > 0;
  const isNegative = numericValue < 0;

  return (
    <span
      className={cn(
        "inline-flex flex-row items-center text-sm font-medium",
        isPositive
          ? "text-constructive"
          : isNegative
            ? "text-destructive"
            : "text-muted-foreground",
        className
      )}
    >
      {isPositive ? (
        <ArrowUp className="h-3 w-3" strokeWidth={3} />
      ) : isNegative ? (
        <ArrowDown className="h-3 w-3" strokeWidth={3} />
      ) : null}
      {formatter(numericValue)}
    </span>
  );
}
